/**
 * AWS Configuration for Tic-Tac-Toe Game
 * This file contains all AWS service configurations and settings
 */

export const AWS_CONFIG = {
  region: process.env.REACT_APP_AWS_REGION || 'eu-west-1',
  
  // DynamoDB Configuration
  dynamodb: {
    gameSessionsTable: process.env.REACT_APP_DYNAMODB_GAME_SESSIONS_TABLE || 'tic-tac-toe-game-sessions',
    userProfilesTable: process.env.REACT_APP_DYNAMODB_USER_PROFILES_TABLE || 'tic-tac-toe-user-profiles',
    roomCodesTable: process.env.REACT_APP_DYNAMODB_ROOM_CODES_TABLE || 'tic-tac-toe-room-codes',
    gameStatisticsTable: process.env.REACT_APP_DYNAMODB_GAME_STATISTICS_TABLE || 'tic-tac-toe-game-statistics',
  },
  
  // API Gateway Configuration
  apiGateway: {
    baseUrl: process.env.REACT_APP_API_GATEWAY_URL || 'https://api.example.com',
    stage: process.env.REACT_APP_API_STAGE || 'prod',
  },
  
  // WebSocket API Configuration
  websocket: {
    url: process.env.REACT_APP_WEBSOCKET_URL || 'wss://websocket.example.com',
  },
  
  // Cognito Configuration
  cognito: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || '',
  },
  
  // Lambda Function Names
  lambda: {
    gameLogic: process.env.REACT_APP_LAMBDA_GAME_LOGIC || 'tic-tac-toe-game-logic',
    userManagement: process.env.REACT_APP_LAMBDA_USER_MANAGEMENT || 'tic-tac-toe-user-management',
    multiplayerManager: process.env.REACT_APP_LAMBDA_MULTIPLAYER_MANAGER || 'tic-tac-toe-multiplayer-manager',
    statisticsManager: process.env.REACT_APP_LAMBDA_STATISTICS_MANAGER || 'tic-tac-toe-statistics-manager',
  },
  
  // Gemini AI Proxy Configuration
  gemini: {
    proxyEndpoint: process.env.REACT_APP_GEMINI_PROXY_ENDPOINT || '',
  }
};

// Validate required configuration
export const validateAWSConfig = (): boolean => {
  const requiredEnvVars = [
    'REACT_APP_COGNITO_USER_POOL_ID',
    'REACT_APP_COGNITO_CLIENT_ID',
    'REACT_APP_API_GATEWAY_URL',
    'REACT_APP_WEBSOCKET_URL'
  ];
  
  const missing = requiredEnvVars.filter(envVar => !process.env[envVar]);
  
  if (missing.length > 0) {
    console.warn('Missing required AWS configuration:', missing);
    return false;
  }
  
  return true;
};